module.exports = __webpack_public_path__ + "static/media/Hands free mode - Tilt.9d69d50b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/Hands free mode - Tilt.mp3
// module id = 2826
// module chunks = 0